import { InsuranceType } from "@nemuru-eng/js-api-client/slim";

export const CARD_NAMES = {
  PAYMENT_MODE_SELECTION: "PAYMENT_MODE_SELECTION",
  FIXED_INSTALMENT_AMOUNT: "FIXED_INSTALMENT_AMOUNT",
};

export const INSURANCE_PACK = {
  PROTECTION_PLUS: "PACK_PROTECTION_PLUS",
  SENIOR: "PACK_SENIOR",
};

export const INSURANCE_RATE_PER_100 = {
  [INSURANCE_PACK.PROTECTION_PLUS]: 0.63,
  [INSURANCE_PACK.SENIOR]: 0.34,
};

export const getInsuranceRate = (insurancePack) =>
  INSURANCE_RATE_PER_100[insurancePack] ??
  INSURANCE_RATE_PER_100[INSURANCE_PACK.PROTECTION_PLUS];

export const formatEuro = (amount, fractionDigits = 2) =>
  `${amount.toFixed(fractionDigits).replace(".", ",")}€`;

export const insuranceMapper = (value) => {
  switch (value) {
    case INSURANCE_PACK.PROTECTION_PLUS:
      return InsuranceType.SEGURO_VIDA_PLUS;
    case INSURANCE_PACK.SENIOR:
      return InsuranceType.SEGURO_VIDA_SENIOR;
    default:
      return undefined;
  }
};

export const PROTECTION_PLUS_PACK_MIN_AGE = 18;
export const SENIOR_PACK_MIN_AGE = 60;
export const SENIOR_PACK_MAX_AGE = 78;
